import type { ApolloClient } from '@apollo/client';

import { GET_CUSTOMER } from 'graphql/queries/getCustomer';

/**
 * Best-effort GET_CUSTOMER refresh after a successful mutation whose outcome
 * must not depend on the refresh (Adyen card/wallet init, payment-card delete).
 * Awaits when the network succeeds so callers can order handoff on a warm cache;
 * swallows failures so a refresh error never rejects or orphans the successful
 * mutation (mutation-level awaitRefetchQueries would).
 */
export const refreshCustomerBestEffort = async (
  client: Pick<ApolloClient<object>, 'refetchQueries'>
): Promise<void> => {
  try {
    await client.refetchQueries({ include: [GET_CUSTOMER] });
  } catch {
    // Best-effort only — local wallet-slot occupancy covers abandon/reopen.
  }
};
